import React, { useState, useRef, useEffect } from "react"
import { navigate } from "gatsby"
import styled from "styled-components"
import { useQuery } from "@apollo/react-hooks"
import { gql } from "apollo-boost"
import useOutsideAlerter from "../helpers/useOutsideAlerter"
import { Spacer } from "../styles/common"
import withApolloClient from "./withApolloClient"
import { useDebounce } from "use-debounce"
import {
  Shimmer,
  // ArrowRight,
  ArrowLeft,
  // Close,
  SearchSmall,
} from "@omnichannel/ace-b2b-elements"
import useWindowDimensions from "../helpers/windowDimensions"
// import { APP_ID } from "../helpers/constants"

/* background-color: ${props =>
    props.theme["595b29c56bce953ca7b20909"].tertiary}; */
const SearchContainer = styled.div`
  /* width: 100%;
  padding: 0 0.4rem 0rem 0.2rem; */
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  border-style: none;
  caret-color: #000;
  color: #000;
  /* background-color: #ef0a0a; */
  background-color: #fa0404;
  max-width: 140rem;
  height: 4.6rem;
  width: 70%;
  border-radius: 0.2rem;
  @media (max-width: 767px) {
    width: 100%;
    background-color: transparent;
    /* background-color: #f90406; */
    border-bottom: solid thin #fff;
    padding: 0 0rem 0rem 0.4rem;
    transform: translateY(0.3rem);
    height: auto;
  }
`

// const CategoryDropdown = styled.div`
//   display: flex;
//   flex-direction: row;
//   align-items: center;
// `

// const CategoryItem = styled.div`
//   font-size: 1.2rem;
//   font-weight: 700;
//   color: #3e3f42;
//   letter-spacing: 0.04rem;
//   line-height: 1.8rem;
//   padding: 0 0.8rem;
// `

const SearchInput = styled.input`
  width: 100%;
  outline: none;
  border: none;
  font-size: 1.6rem;
  letter-spacing: 0.4px;
  line-height: 22px;
  border-radius: 0;
  padding-left: 0rem;
  caret-color: #fff;
  /* background-color: #c2171d; */
  /* background-color: #f90406; */
  background-color: transparent;
  color: #fff;
  &::placeholder {
    color: #fff;
  }
  @media (min-width: 768px) {
    /* background-color: #ef0a0a; */
    background-color: #fa0404;
    color: #fff;
    width: 100%;
    outline: none;
    border: none;
    font-size: 1.6rem;
    letter-spacing: 0.4px;
    line-height: 22px;
    border-radius: .2rem;
    padding-left: 2rem;
    &::placeholder {
      color: #fff;
    }
  }
`

const IconContainer = styled.div`
  cursor: pointer;
  padding-right: 2rem;
`

const IconContainerMobile = styled(IconContainer)`
  padding-right: 0;
  cursor: pointer;
`

const SuggestionContainer = styled.div`
  max-width: 140rem;
  width: 100%;
  position: absolute;
  @media (max-width: 767px) {
    left: 0;
    right: 0;
  }
`

const SearchSuggestions = styled.div`
  background-color: #fff;
  position: absolute;
  top: 3rem;
  width: 100%;
  min-height: 20rem;
  left: 0rem;
  border-radius: 0.2rem;
  right: 0;
  z-index: 9999;
  max-width: 140rem;
  padding: 2rem;
  box-shadow: 0px 0.5px 3px rgba(0, 0, 0, 0.1);
  @media (max-width: 767px) {
    width: 100%;
    left: 0rem;
    padding: 1.4rem 2rem;
    border-radius: 0;
  }
`

const SearchTitle = styled.div`
  font-size: 1.6rem;
  color: #3e3f42;
  line-height: 2.4rem;
  font-weight: 700;
`

const ResultContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const SuggestionRow = styled.div`
  display: flex;
  flex-direction: row;
  border-bottom: #d8d8d8 1px solid;
  padding: 1.4rem 0;
  align-items: center;
  cursor: pointer;
  transition: 0.5s background-color ease-out;
  &:hover {
    /* background-color: ${props => props.theme.default.secondarySky25P}; */
    background-color: #E6E6E6;
  }
  &:last-of-type {
    border-bottom: none;
  }
  @media (min-width: 1024px) {
    padding: 1.5rem 0;
  }
`

const SuggestTitle = styled.div`
  font-size: 1.6rem;
  color: #3e3f42;
  padding-left: 1rem;
  line-height: 1.5rem;
`

const ShowAll = styled(SuggestTitle)`
  color: ${props => props.theme.default.primary};
`

const SuggestPrice = styled.div`
  font-size: 1.8rem;
  color: #000;
  font-weight: 600;
  line-height: 3rem;
  padding-left: 1rem;
`

const SuggestImage = styled.img`
  margin-left: 0.8rem;
  max-width: 8rem;
  max-height: 8rem;
`

const SuggestDetails = styled.div``

const HeaderContainer = styled.div`
  /* background-color: #c2171d; */
  background-image: linear-gradient(to right, #e8171e, #c2171d);
  display: flex;
  align-items: center;
  padding: 5 1.6rem 0 0.4rem;
  width: 100%;
  @media (min-width: 1024px) {
    display: none;
  }
`

const HeaderContent = styled.div`
  padding: 0;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  max-width: 140rem;
  height: 6.6rem;
  width: 100%;
  padding-right: 1.2rem;
  @media (min-width: 1024px) {
    padding-right: 0;
  }
`

const IconBox = styled.div`
  display: flex;
  justify-content: center;
  padding: 0;
  width: 4rem;
`

const MobileSuggestionContainer = styled.div`
  max-width: 140rem;
  width: 100%;
  min-height: 53rem;
`

const MobileSearchSuggestions = styled.div`
  background-color: #fff;
  top: 4rem;
  width: 100%;
  min-height: 20rem;
  left: 0rem;
  border-radius: 0;
  right: 0;
  z-index: 200;
  max-width: 140rem;
  padding: 1.4rem 2rem;
`

const EmptyResults = props => {
  return <SearchTitle>{`No Results for "${props.searchTerm}"`}</SearchTitle>
}

const SearchResults = props => {
  if (props.loading) {
    return (
      <ResultContainer>
        <SuggestionRow>
          <Shimmer width="100%" height="3rem" />
        </SuggestionRow>
        <SuggestionRow>
          <Shimmer width="100%" height="3rem" />
        </SuggestionRow>
        <SuggestionRow>
          <Shimmer width="100%" height="3rem" />
        </SuggestionRow>
      </ResultContainer>
    )
  } else if (props.type === "popular") {
    return (
      <ResultContainer>
        <SearchTitle>Popular Searches</SearchTitle>
        {(props.results.keywords || []).map((item, index) => {
          return (
            <SuggestionRow
              key={index}
              onClick={() => props.navigateToSeeAll(item)}
            >
              <SuggestTitle>{item}</SuggestTitle>
            </SuggestionRow>
          )
        })}
      </ResultContainer>
    )
  } else {
    return (
      <ResultContainer>
        {props.results.skuSuggestion.slice(0, 6).map((item, index) => {
          return index < 3 ? (
            <SuggestionRow
              key={index}
              onClick={() => navigate(`/product/${item._id}`)}
            >
              <SuggestImage src={item.primaryImage} />
              <SuggestDetails>
                <SuggestTitle>{item.name}</SuggestTitle>
                <SuggestPrice>P{item.currentPrice}</SuggestPrice>
              </SuggestDetails>
            </SuggestionRow>
          ) : (
              <SuggestionRow
                key={index}
                onClick={() => navigate(`/product/${item._id}`)}
              >
                <SuggestTitle>{item.name}</SuggestTitle>
              </SuggestionRow>
            )
        })}
        <SuggestionRow onClick={props.viewAll}>
          <SuggestDetails>
            <ShowAll>{'Show All >'}</ShowAll>
          </SuggestDetails>
          <Spacer width={"1rem"} />
          {/* <ArrowRight width={"13"} height={"13"} color={"#3e3f42"} /> */}
        </SuggestionRow>
      </ResultContainer>
    )
  }
}

const SearchBar = props => {

  const [searchKey, setSearchKey] = useState("")
  const [showSuggestions, setShowSuggestions] = useState(false)
  const [debouncedSearchTerm] = useDebounce(searchKey, 500)
  const wrapperRef = useRef(null)
  const searchInputRef = useRef(null)

  const { width } = useWindowDimensions()
  useEffect(() => {
    if (props.autoFocus) {
      searchInputRef.current.focus()
      setShowSuggestions(true)
    }
  }, [])

  let searchPlaceholderText = "What can we help you find?"
  if (width >= 768) {
    searchPlaceholderText = "What can we help you find?"
  }

  useOutsideAlerter(wrapperRef, () => {
    setSearchKey("")
    setShowSuggestions(false)
    if (props.onClose) {
      props.onClose()
    }
  })

  const { data, loading } = useQuery(searchQuery, {
    variables: {
      keyword: debouncedSearchTerm,
    },
  })

  const navigateToSeeAll = key => {
    navigate(`/search?keyword=${key}`)
    setShowSuggestions(false)
    setSearchKey("")
  }

  const onKeyPress = e => {
    if (e.key === "Enter") {
      sessionStorage.removeItem(`search::${debouncedSearchTerm}::scrollTo`)
      navigateToSeeAll(searchKey)
    }
  }

  const { esSearchSuggestions = {} } = data || {}

  let type = "popular"

  if (debouncedSearchTerm) {
    if (esSearchSuggestions.totalMatches > 0) {
      type = "skus"
    } else if (loading) {
      type = "popular"
    } else {
      type = "empty"
    }
  } else {
    type = "popular"
  }

  return (
    <>
      {/* <CategoryDropdown>
        <CategoryItem>ALL</CategoryItem>
        <Icons icon={Icon.ChevronDown} size={"2rem"} color={"#7C878E"} />
      </CategoryDropdown> */}
      {props.isMobile ? (
        <>
          <HeaderContainer>
            <div
              onClick={() =>
              // window.location.replace(
              //   props.prevPath ? `${props.prevPath}` : "/"
              // )
              {
                const previousSearchKey = props.location.state.searchKey
                navigate(`${props.prevPath ? `${props.prevPath}` : "/"}`, {
                  state: { searchKey: searchKey ? searchKey : previousSearchKey ? previousSearchKey : "" }
                })
              }
              }
            >
              <IconBox>
                <ArrowLeft width={"15"} height={"15"} color={"#FFF"} />
              </IconBox>
            </div>
            <HeaderContent>
              <SearchContainer ref={wrapperRef}>
                <SearchInput
                  placeholder={searchPlaceholderText}
                  value={searchKey}
                  onKeyDown={e => onKeyPress(e)}
                  onChange={input => {
                    setShowSuggestions(true)
                    setSearchKey(input.currentTarget.value)
                  }}
                  onClick={() => setShowSuggestions(true)}
                  ref={searchInputRef}
                />
                <IconContainerMobile
                  onClick={
                    searchKey || showSuggestions
                      ? () => {
                        setShowSuggestions(false)
                        setSearchKey("")
                        if (props.onClose) {
                          props.onClose()
                        }
                      }
                      : () => { }
                  }
                >
                  <SearchSmall width={20} height={20} color={"#FFF"} />
                </IconContainerMobile>
              </SearchContainer>
            </HeaderContent>
          </HeaderContainer>
          <MobileSuggestionContainer ref={wrapperRef}>
            <MobileSearchSuggestions>
              {type === "empty" ? (
                <EmptyResults searchTerm={debouncedSearchTerm} />
              ) : (
                  <SearchResults
                    results={esSearchSuggestions}
                    type={type}
                    loading={loading}
                    navigateToSeeAll={navigateToSeeAll}
                    viewAll={() => {
                      sessionStorage.removeItem(`search::${debouncedSearchTerm}::scrollTo`)
                      navigateToSeeAll(debouncedSearchTerm)
                    }}
                  />
                )}
            </MobileSearchSuggestions>
          </MobileSuggestionContainer>
        </>
      ) : (
          <SearchContainer ref={wrapperRef}>
            <SearchInput
              placeholder={searchPlaceholderText}
              value={searchKey}
              onKeyDown={e => onKeyPress(e)}
              onChange={input => {
                setShowSuggestions(true)
                setSearchKey(input.currentTarget.value)
              }}
              onClick={() => setShowSuggestions(true)}
              ref={searchInputRef}
            />
            <IconContainer
              onClick={
                searchKey || showSuggestions
                  ? () => {
                    setShowSuggestions(false)
                    setSearchKey("")
                    if (props.onClose) {
                      props.onClose()
                    }
                  }
                  : () => { }
              }
            >
              <SearchSmall width={24} height={24} color={"#FFF"} />
            </IconContainer>
            {(searchKey || showSuggestions) && (
              <SuggestionContainer ref={wrapperRef}>
                <SearchSuggestions>
                  {type === "empty" ? (
                    <EmptyResults searchTerm={debouncedSearchTerm} />
                  ) : (
                      <SearchResults
                        results={esSearchSuggestions}
                        type={type}
                        loading={loading}
                        navigateToSeeAll={navigateToSeeAll}
                        viewAll={() => {
                          sessionStorage.removeItem(`search::${debouncedSearchTerm}::scrollTo`)
                          navigateToSeeAll(debouncedSearchTerm)
                        }}
                      />
                    )}
                </SearchSuggestions>
              </SuggestionContainer>
            )}
          </SearchContainer>
        )}
    </>
  )
}

const searchQuery = gql`
  query esSearchSuggestionsQuery($keyword: String) {
    esSearchSuggestions(keyword: $keyword) {
      keywordUsed
      keywords
      categorySuggestion
      brandSuggestion
      totalMatches
      skuSuggestion {
        _id
        primaryImage
        referencePrice
        currentPrice
        name
      }
    }
  }
`

export default withApolloClient(SearchBar, { client: "seeAllClient" })
